export const REACT_APP_SUB_DOMAIN = window.location.hostname.split('.')[0];
export const REACT_APP_BASE_URL = window.location.origin;
export const REACT_APP_API_BASE_URL = `${window.location.origin}/portal`;
export const REACT_APP_API_GATEWAY_BASE_URL = `${window.location.origin}/api-gateway`;
export const REACT_APP_BOTSTORE_URL = 'https://botstore.app.engati.com/';
export const PASSWORD_MIN_LENGTH = 15;
export const PASSWORD_PREFERRED_LENGTH = 15;
export const PASSWORD_MAX_LENGTH = 64;
